import { motion } from "framer-motion";
import { IMAGES } from "@/data";

const TILES = [
  { src: IMAGES.hero_banner, label: "Signature Clouds", span: "col-span-2 row-span-2" },
  { src: IMAGES.event_live_spinning, label: "Live Spinning", span: "col-span-2" },
  { src: IMAGES.spun_cloud_pink, label: "Pink Nebula", span: "" },
  { src: IMAGES.gourmet_sweet_sticks, label: "Gourmet Sticks", span: "" },
  { src: IMAGES.event_party_vibes, label: "Party Atmosphere", span: "col-span-2" },
  { src: IMAGES.candy_bowl_overhead, label: "Candy Craft", span: "" },
  { src: IMAGES.colorful_sweet_jar, label: "Sugar Spectrum", span: "" },
  { src: IMAGES.cosmic_nebula_bg, label: "Deep Space Sugar", span: "col-span-2" },
];

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="relative py-24 sm:py-32 bg-cosmic-elevated/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-12">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-cosmic-cyan">From the Field</span>
        <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
          Moments in the <span className="text-gradient-candy">sugar nebula</span>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[170px] sm:auto-rows-[200px] gap-4" data-testid="gallery-grid">
        {TILES.map((t, i) => (
          <motion.figure
            key={t.label}
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.05 }}
            className={`group relative overflow-hidden rounded-2xl border border-white/10 ${t.span}`}
            data-testid={`gallery-tile-${i}`}>
            <img src={t.src} alt={t.label} loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-cosmic-base/90 to-transparent p-4 pt-10">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-cosmic-cyan">{t.label}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
